var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import React, { useEffect, useState } from "react";
import { CustomCheckbox } from "./CustomCheckbox";
import { Dropdown } from "./Dropdown";
export var CustomSelect = function (_a) {
    var id = _a.id, name = _a.name, label = _a.label, value = _a.value, align = _a.align, error = _a.error, onClose = _a.onClose, options = _a.options, onChange = _a.onChange, multiple = _a.multiple, className = _a.className, placeholder = _a.placeholder, showSelected = _a.showSelected, customElement = _a.customElement, _b = _a.disabled, disabled = _b === void 0 ? false : _b, _c = _a.searchInOptions, searchInOptions = _c === void 0 ? false : _c;
    var _d = useState(false), forceClose = _d[0], setForceClose = _d[1];
    var _e = useState(''), searchTxt = _e[0], setSearchTxt = _e[1];
    var populateSelectedOptions = function (values) {
        if (!!values.length) {
            if (values[0] === "ALL") {
                return "All";
            }
            return values.map(function (value) {
                var option = options.find(function (o) { return o.value === value; });
                return (React.createElement("div", { className: "selected-option", onClick: function (e) {
                        e.preventDefault();
                        e.stopPropagation();
                        changeHandler(option);
                    } }, option === null || option === void 0 ? void 0 : option.label));
            });
        }
        return placeholder || "None Selected";
    };
    var getTitle = function (newValue) {
        if (label) {
            return label;
        }
        if (newValue && !multiple) {
            var selectedOptions = options.filter(function (option) { return option.value === newValue; });
            if (selectedOptions && selectedOptions[0]) {
                return selectedOptions[0].label;
            }
        }
        if (showSelected && multiple) {
            return populateSelectedOptions(newValue);
        }
        return placeholder || "Select Option...";
    };
    var _f = useState(getTitle(value)), title = _f[0], setTitle = _f[1];
    // changes the title of the dropdown on changes to value
    useEffect(function () {
        if (value) {
            setTitle(getTitle(value));
        }
        else {
            setTitle(getTitle(''));
        }
    }, [value]);
    var changeHandler = function (option) {
        var newValue;
        if (multiple && value) {
            newValue = __spreadArray([], value);
            // adds
            if (!newValue.includes(option.value)) {
                newValue = __spreadArray(__spreadArray([], newValue), [option.value]);
            }
            else {
                // removes
                newValue.splice(newValue.indexOf(option.value), 1);
            }
        }
        var generatedTarget = {
            target: {
                name: name || "custom-select",
                value: multiple && value ? newValue : option.value,
            },
        };
        onChange(generatedTarget, option);
        if (!multiple) {
            setForceClose(true);
        }
    };
    return (React.createElement(Dropdown, { title: title, onClose: onClose, disabled: disabled, align: align || "left", forceClose: forceClose, setForceClose: setForceClose, className: "custom-select " + (className || "") + " " + (error ? "error" : "") + " " + (disabled ? "disabled" : "") + " " + (title === placeholder ? 'muted-text' : '') },
        searchInOptions &&
            React.createElement("div", { className: "search-container" },
                React.createElement("input", { type: 'text', value: searchTxt, onChange: function (e) { return setSearchTxt(e.target.value); }, placeholder: 'Search' })),
        React.createElement("ul", { className: "select-list" },
            options &&
                options
                    .filter(function (option) { return searchTxt.length > 0 ?
                    option.label.toString().toLowerCase().includes(searchTxt.toLowerCase()) : true; })
                    .map(function (option, i) {
                    var checked;
                    if (multiple) {
                        checked = value ? value.includes(option.value) : false;
                    }
                    return (React.createElement("li", { key: "option-" + i, onClick: function (e) { return changeHandler(option); }, className: "selected-option " + (option.disabled ? "disable-select-option" : "") + " " + (value === option.value ? 'd-none-imp' : '') },
                        multiple && value && React.createElement(CustomCheckbox, { checked: checked, disabled: (option === null || option === void 0 ? void 0 : option.disabled) ? true : false }),
                        React.createElement("span", { className: "label" }, option.label)));
                }),
            customElement)));
};
